// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.genter-input {
  border: 1px solid #b8c2cc;
  cursor: pointer;
  border-radius: 50%;
  margin-right: 10px;
}

.form-group-button {
  margin: 25px 0;
}

.control-validate.ng-touched.ng-invalid, .control-validate.ng-touched.ng-valid {
  background-image: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
